import apiClient from "../services/apiClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function submitQuoteRequest(formData) {
  const { data } = await apiClient.post("/api/quote/requests", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return unwrapApiResponse({ data });
}
